<template>
    <modal size="lg" :height-max="true" @close="reset(); $emit('close')" ref="modal" :is-closeable="isCloseable" id="editDeductionPositionsModal">
        <template v-slot:title>
            <h3 class="modal-title">Edit Positions</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div v-if="deduction.company"><span class="text-muted">Company: </span>{{ deduction.company.name }}</div>
                    <div><span class="text-muted">Deduction: </span>{{ deduction.name || deduction.deduction_type.name }}</div>
                </div>
            </div>

            <form-errors :errors="formErrors"/>

            <div class="mb-2">
                <form-input
                    v-model="formData.default_for_all_positions"
                    :errors="errors.default_for_all_positions"
                    type="checkbox"
                    label="Available to all positions"
                    helper-text="Every position at this company can use this deduction type, including positions added later."
                />
            </div>

            <template v-if="!formData.default_for_all_positions">
                <p class="mb-0">Select the positions that can use this deduction type.</p>

                <position-selector v-if="positionsLoaded" :all-positions="allCompanyPositions" :companies="client.companies" v-model="formData.positions"/>
            </template>

        </slot>

        <template v-slot:footer>
            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import PositionSelector from '@/pages/client/Settings/components/PositionSelector'

export default {
    props: ['client', 'deduction'],
    mixins: [FormMixin, ModalMixin],
    components: {PositionSelector, },
    data() {
        return {
            formData: this.makeFormData(),
            allPositions: [],
            positionsLoaded: false,
        }
    },
    watch: {
        deduction() {
            this.reset()
        }
    },
    mounted() {
        this.getPositions()
    },
    computed: {
        allCompanyPositions() {
            return this.allPositions.filter(p => p.company_id == this.deduction.company_id)
        },
    },
    methods: {
        getPositions() {
            this.$api.get(`/clients/${this.client.id}/positions`).then(resp => {
                this.allPositions = resp
                this.allPositions.sort((a, b) => {return a.terminal_value.toLowerCase() > b.terminal_value.toLowerCase() ? 1 : -1})
                this.positionsLoaded = true
            }).catch((errors) => {
                this.$bus.showError(errors.__all__)
            })
        },
        makeFormData() {
            const data = {
                positions: [],
                default_for_all_positions: !!this.deduction.default_for_all_positions,
            }
            this.deduction.position_rels.forEach(rel => {
                data.positions.push(rel.position.id)
            })
            return data
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            return this.$api.put(`/clients/${this.client.id}/settings/deduction-types/${this.deduction.id}/positions`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        }
    }
}
</script>
